import React, { useState } from "react";
import "../../../assets/css/Headerr.css";
import QuickLinksLogoo from "../../../assets/img/Quick Linkscropped-Rentel-Website-06.png";
import { IoIosClose } from "react-icons/io";
import { CgMenuRight } from "react-icons/cg";
import { Link } from "react-router-dom";
import NoCopyWrapper from "../../../utils/NoCopyWrapper";
import NoZoomWrapper from "../../../utils/NoZoomWrapper";
const Headerr = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <NoZoomWrapper>
      <NoCopyWrapper>
        <div className="container">
          <header className="headerr">
            {/* Logo */}
            <div className="logo-section">
              <Link to="/">
                <img
                  src={QuickLinksLogoo}
                  alt="Rentel Logo"
                  className="logoo"
                />
              </Link>
            </div>

            {/* Desktop Navigation */}
            <nav className="nava-linkse desktop-nav">
              <ul className="menu">
                <li>
                  <Link to="/about">About</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </nav>

            {/* Desktop Button */}
            <Link
              to="/Download"
              className="download-btn desktop-nav"
            >
              Download Now
            </Link>

            {/* Mobile Hamburger */}
            <div
              className="hamburger mobile-onlya"
              onClick={() => setMenuOpen(true)}
            >
              <CgMenuRight size={28} className="hamburgerf-icon" />{" "}
              {/* 🔹 Proper hamburger icon */}
            </div>
          </header>

          {/* Mobile Sidebar */}
          <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
            <button className="close-btns" onClick={() => setMenuOpen(false)}>
              <IoIosClose className="chokdi" size={32} />
            </button>
            <nav>
              <ul className="menu">
                <li>
                  <Link to="/about">About</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </NoCopyWrapper>
    </NoZoomWrapper>
  );
};

export default Headerr;
